import React, {useRef} from "react"
import {AllowedIncomingChecksColumns, IncomingChecksColumns} from "./IncomingCheck.types"
import {Resource} from "../../resources/common"
import {useNavigateWithListPath} from "../../hooks/useListReturnPath"
import {IncomingCheck} from "../../resources/incomingCheck"
import {DataTable, DataTableBody, DataTableCell, DataTableHead, DataTableRow} from "../DataTable/DataTable"
import PagingNavBar from "../PagingNavBar/PagingNavBar"
import IncomingCheckRow from "./IncomingCheckRow"

interface IncomingChecksTableProps {
	incomingChecks: IncomingCheck[]
	includedColumns: AllowedIncomingChecksColumns[]
	isUsingPaging: boolean
	hasResults: boolean
	hasPrev: boolean
	hasNext: boolean
	prev: () => void
	next: () => void
	refresh: () => void
	include?: Resource[]
	fullHeight?: boolean
	stickyAction?: boolean
}

export function IncomingChecksTable({
	incomingChecks,
	includedColumns,
	hasResults,
	isUsingPaging,
	hasPrev,
	hasNext,
	prev,
	next,
	refresh,
	include,
	fullHeight = true,
	stickyAction = true,
}: IncomingChecksTableProps) {
	const noContent = incomingChecks.length === 0
	const ref = useRef(null)
	const navigateWithListPath = useNavigateWithListPath()

	return (
		<div ref={ref} className={"incoming-checks-table"}>
			<DataTable
				isEmpty={noContent}
				fullHeight={fullHeight}
				stickyAction={stickyAction}
				noContentText={"No incoming checks found"}
			>
				<DataTableHead>
					<DataTableRow>
						{Object.entries(includedColumns).map((column) => {
							if (column[1] === IncomingChecksColumns.createdAt) {
								return <DataTableCell key={column[1]}>{column[1]}</DataTableCell>
							}

							return <DataTableCell key={column[0]}>{column[1]}</DataTableCell>
						})}
					</DataTableRow>
				</DataTableHead>
				<DataTableBody>
					{incomingChecks.map((check) => (
						<IncomingCheckRow
							incomingCheck={check}
							key={check.id}
							include={include}
							onClick={(e) => {
								e.preventDefault()
								e.stopPropagation()
								navigateWithListPath(`/incoming-checks/${check.id}`)
							}}
							refresh={refresh}
							includedColumns={includedColumns}
						/>
					))}
				</DataTableBody>
			</DataTable>
			<PagingNavBar
				hasResults={hasResults}
				hasPrev={hasPrev}
				hasNext={hasNext}
				prev={prev}
				next={next}
				isShow={isUsingPaging}
			/>
		</div>
	)
}
